import { useCallback, useEffect } from "react";

const KEY_NAME_ENTER = "Enter"; // no itx
const KEY_EVENT_TYPE = "keyup"; // no itx

export default function useEnterKeyAsOk(handleOnOk: any) {
  const handleEnterKey = useCallback(
    (event: any) => {
      if (event.key === KEY_NAME_ENTER) {
        if (handleOnOk instanceof Function) {
          handleOnOk();
        }
      }
    },
    [handleOnOk],
  );

  useEffect(() => {
    document.addEventListener(KEY_EVENT_TYPE, handleEnterKey, false);

    return () => {
      document.removeEventListener(KEY_EVENT_TYPE, handleEnterKey, false);
    };
  }, [handleEnterKey]);
}
